// libraries.
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { monserratSemiBold } from '@habitech/shared';

// components.
import { CoordinateInputs } from './CoordinateInputs';
import { Line } from '@shared/styles';

// hooks.
import { useGeoreferencingWebSocket } from '../hooks';

// selectors.
import { getSelectedBusinessLine } from '../store/slices/georeferencing-slice';

export const FieldsToCorrect = () => {
  const selectedBusinessLine = useSelector(getSelectedBusinessLine);

  const { sendGeoreferencing, isLoading, canSend } = useGeoreferencingWebSocket(
    {}
  );

  if (!selectedBusinessLine) {
    return null;
  }

  return (
    <div className="d-flex flex-column h-100">
      {/* Título */}
      <div className="p-3" style={{ backgroundColor: '#f9f9f9' }}>
        <h5
          style={{
            fontFamily: monserratSemiBold,
            fontSize: '16px',
          }}
        >
          Campos a corregir
        </h5>
      </div>
      <div className="p-3 flex-grow-1" style={{ overflowY: 'auto' }}>
        <CoordinateInputs />
      </div>
      <div className="d-flex flex-column gap-3 px-3 pb-3">
        <Line />
        <div className="d-flex">
          <Button
            className="w-100 btn-habi"
            type="button"
            onClick={sendGeoreferencing}
            disabled={!canSend || isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar'}
          </Button>
        </div>
      </div>
    </div>
  );
};
